// Copyright (c) 2019 Deere & Company
import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import {
    addPartToComponentFunctionCode, deleteComponentPartNumber, editComponentPartNumber,
    getAdminReport, getAdminReportDownload, getComponentFactoryCode, getComponentSearchCode,
} from '../../repositories';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import CFCMAside from './aside';
//import CSVFile from '../../../assets/component_function_code.csv';
import ComponentCodeSearchPanel from '../component-code-search-panel';
import ComponentFunctionCodePanel from '../component-code-input-panel';
import { ConfirmationModal } from '../../../shared/components/modals/confirmation-modal';
// import MultipleEntryPopup from './multiple-entry-popup';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
import ComponentFunctionCodeMultipleEntryPopup from './component-function-code-multiple-entry-popup';
import { downloadSampleReports } from '../../../claims/repositories';

export class ComponentFunctionCodeMaintenance extends Component {

  state = {
      componentSearchCodes: [],
      componentDropdownList: [],
      isEdit: false,
      isAdd: false,
      confirmMessage: '',
      confirmTitle: '',
      confirmIsOpen: false,
      componentFunctionCodeSearch: {
          componentfactoryText: -1,
          componentPartNoText: '',
          manufacturingFactText: '',
          modalCodeText: '',
          componentFuncCodeText: '',
          modelIsOpen: false,
          modelIsClose: false,

      },
      selectedComponentFunctionCode: {},
  };


  componentWillMount = () => {

      this.loadDefault();
      this.ComponentFctoryDropdownList();

  }

  componentWillReceiveProps ( nextProps ) {

      if ( nextProps.reload === 'componentCode' ) {

          this.loadDefault();
          this.ComponentFctoryDropdownList();
          nextProps.updateReload();

      }

  }


    loadDefault = () => {

        this.setState( {
            isEdit: false,
            isAdd: false,
            componentSearchCodes: [],
            componentFunctionCodeSearch: {
                componentfactoryText: -1,
                componentPartNoText: '',
                manufacturingFactText: '',
                modalCodeText: '',
                componentFuncCodeText: '',
            },

        } );

    }

  componentDropDowninfo = id => {

      const cf = this.state.componentFunctionCodeSearch;
      cf.componentfactoryText = id;
      this.setState( {
          componentFunctionCodeSearch: cf,
      } );

  };

  handleAsideCompFactoryDropdown = id => {

      const cf = this.state.selectedComponentFunctionCode;
      this.state.componentDropdownList.forEach( dropDownlist => {

          if ( dropDownlist.factoryCode === id ) {

              cf.factoryCode = dropDownlist.factoryCode;
              cf.factoryDescription = dropDownlist.factoryDescription;

          }

      } );
      cf.factoryCode = id;
      this.setState( {
          selectedComponentFunctionCode: cf,
      } );

  };

  handleComponentMainTextChange = event => {

      const desired = event.target.value.replace( /[^\w\s]/gi, '' ).trim();
      const componentFunctionCodeSearch = { ...this.state.componentFunctionCodeSearch };
      componentFunctionCodeSearch[event.target.name] = desired;
      this.setState( { componentFunctionCodeSearch } );

  };


  ComponentFctoryDropdownList = () => {

      this.props.increaseCounter();
      getComponentFactoryCode().then( response => {

          const componentFnCodeDropdwnList = [];
          response.forEach( seriesList => {

              componentFnCodeDropdwnList.push( {
                  factoryCode: seriesList.factoryCode,
                  factoryDescription: `${seriesList.factoryCode} - ${seriesList.factoryDescription}`,
              } );

          } );
          this.setState( {
              componentDropdownList: componentFnCodeDropdwnList,
          } );
          this.props.decreaseCounter();

      } ).catch( () => {

          this.props.decreaseCounter();

      } );

  };

  handleAddClick = () => {

      this.setState( {
          isEdit: true,
          isAdd: true,
          selectedComponentFunctionCode: {
              componentFactoryCode: '',
              componentFunctionCodeId: '',
              componentFunctionCodeName: '',
              componentGroupCode: '',
              componentPartNumber: '',
              manufacturingFactoryCode: '',
              model: '',
          },
      } );

  };

  handleCancelClick = () => {

      this.setState( {
          isEdit: false,
          isAdd: false,
      } );

  }

  handleSearchClick = () => {

      this.props.increaseCounter();
      getComponentSearchCode( this.state.componentFunctionCodeSearch ).then( response => {

          this.setState( {
              componentSearchCodes: response,
          } );
          this.props.decreaseCounter();

      } ).catch( () => {

          this.props.decreaseCounter();

      } );

  };

  handleDeleteClick = () => {

      this.setState( {
          confirmMessage: 'Are you sure you want to Delete?',
          confirmIsOpen: true,
          confirmTitle: 'Confirm Delete?',
      } );

  };

  onComponentFactorySelect = obj => {

      const selectedComponentPartObj = {
          componentFactoryCode: obj.componentFactoryCode,
          componentFunctionCodeId: obj.componentFunctionCodeId,
          componentFunctionCodeName: obj.componentFunctionCodeName,
          componentGroupCode: obj.componentGroupCode,
          componentPartNumber: obj.componentPartNumber,
          manufacturingFactoryCode: obj.manufacturingFactoryCode,
          model: obj.model,
          selObj: `${obj.componentPartNumber}_${obj.manufacturingFactoryCode}_${obj.model}_${obj.componentFunctionCodeName}`,
      };
      this.setState( {
          selectedComponentFunctionCode: selectedComponentPartObj,
          isEdit: true,
      } );

  };

  handleConfirmClose = () => {

      this.setState( {
          confirmIsOpen: false,
      } );

  };

  handleConfirm = () => {

      this.props.increaseCounter();
      deleteComponentPartNumber( this.state.selectedComponentFunctionCode ).then( () => {

          this.setState( {
              confirmIsOpen: false,
              isEdit: false,
          } );
          this.props.increaseCounter();
          getComponentSearchCode( this.state.componentFunctionCodeSearch ).then( response => {

              this.setState( {
                  componentSearchCodes: response,
              } );
              this.props.decreaseCounter();
              this.props.createSuccessMessage( 'Delete Component Function Code Successful' );

          } ).catch( () => {

              this.props.decreaseCounter();

          } );
          this.props.decreaseCounter();

      } ).catch( () => {

          this.props.decreaseCounter();

      } );

  };

  handleAsideTextChange = event => {

      const curObj = this.state.selectedComponentFunctionCode;
      curObj[event.target.name] = event.target.value;
      this.setState( {
          selectedComponentFunctionCode: curObj,
      } );

  };

  handleAsideUpdate = () => {

      if ( !this.state.isAdd ) {

          this.props.increaseCounter();
          editComponentPartNumber( this.state.selectedComponentFunctionCode ).then( () => {

              this.props.increaseCounter();
              getComponentSearchCode( this.state.componentFunctionCodeSearch ).then( response => {

                  this.setState( {
                      componentSearchCodes: response,
                      isEdit: false,
                      isAdd: false,
                  } );
                  this.props.decreaseCounter();
                  this.props.createSuccessMessage( 'Update Component  Function Code Successful' );

              } ).catch( () => {

                  this.props.decreaseCounter();

              } );
              this.props.decreaseCounter();

          } ).catch( () => {

              this.props.decreaseCounter();

          } );

      } else {

          const obj = { ...this.state.selectedComponentFunctionCode };
          this.props.increaseCounter();
          addPartToComponentFunctionCode( obj ).then( () => {

              this.setState( {
                  isEdit: false,
                  isAdd: false,
              } );
              this.props.decreaseCounter();
              this.props.createSuccessMessage( 'Add New Component Function Code Successful' );

          } ).catch( () => {

              this.props.decreaseCounter();

          } );

      }

  };

  downLoadReport = () => {

      this.props.increaseCounter();

      getAdminReport( 'componentFunctionCode', this.state.componentFunctionCodeSearch.componentfactoryText, '' )
          .then( response => {

              getAdminReportDownload( response, 'component_function_code.csv' );
              this.props.decreaseCounter();

          } ).catch( () => {

              this.props.decreaseCounter();

          } );

  };

  onUploadReport = () => {

      this.setState( {
          modelIsOpen: true,
      } );

  }

onUploadReportClose = () => {

    this.setState( {
        modelIsOpen: false,
    } );

};
handleDownloadClick = (fileName) => () => {
        console.log("fileName", fileName);
        
        this.props.increaseCounter();

        downloadSampleReports(fileName)
            .then(response => {
                response.blob().then( blob => {

                    const url = window.URL.createObjectURL( blob );
                    const a = document.createElement( 'a' );
                    a.setAttribute( 'download', fileName+'.csv' );
                    a.href = url;
                    document.body.appendChild( a );
                    a.click();
                    a.parentNode.removeChild( a );
            
                } );
                this.props.decreaseCounter();
            })
            .catch(() => {
                this.props.decreaseCounter();
            });
    }


  render = () => (
      <section>
          <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
          <header>
              <h2 className="page-header">Component Function Code Maintenance
                  {!this.state.isAdd &&
                      <button className="report-button" type="button" onClick={this.downLoadReport} disabled={this.state.componentFunctionCodeSearch.componentfactoryText === -1}>Download Report</button>
                  }
                  {!this.state.isAdd &&
                      <button className="report-button" type="button" onClick={this.onUploadReport}>Upload Report</button> }
                  {/* <a title="Field having values can update only" href={CSVFile} className="upload-report-label" download="component_function_code.csv">Download Sample Report</a> */}
                  <a
                        className="upload-report-label"
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('component_function_code')}
                    >
                        Download Sample Report
                    </a>
              </h2>
          </header>

          <main className="section-with-aside">
              {!( this.state.isEdit && this.state.isAdd ) && (
                  <ComponentFunctionCodePanel
                      onTextChange={this.handleComponentMainTextChange}
                      handleSearchClick={this.handleSearchClick}
                      componentDropdownList={this.state.componentDropdownList}
                      componentDropDowninfo={this.componentDropDowninfo}
                      handleAddClick={this.handleAddClick}
                      componentFunctionCodeSearch={this.state.componentFunctionCodeSearch}
                  />
              )}
          </main>
          <div className="section-with-aside">
              {this.state.componentSearchCodes.length > 0 &&
              !( this.state.isEdit && this.state.isAdd ) && (
                  <main>
                      <ComponentCodeSearchPanel
                          productList={this.state.componentSearchCodes}
                          onComponentFactorySelect={this.onComponentFactorySelect.bind( this )}
                          selectedComponentFunctionCode={this.state.selectedComponentFunctionCode}
                      />
                  </main>
              )}
              {this.state.componentSearchCodes.length === 0 &&
              !( this.state.isEdit && this.state.isAdd ) && <main>No Result Found</main>}
              <aside>
                  <CFCMAside
                      isEdit={this.state.isEdit}
                      componentpartNumber={this.state.selectedComponentFunctionCode}
                      onDelete={this.handleDeleteClick}
                      handleAsideTextChange={this.handleAsideTextChange}
                      onUpdate={this.handleAsideUpdate}
                      isAdd={this.state.isAdd}
                      handleAsideCompFactoryDropdown={this.handleAsideCompFactoryDropdown}
                      componentDropdownList={this.state.componentDropdownList}
                      onCancel={this.handleCancelClick.bind( this.props )}
                  />
                  <ConfirmationModal
                      body={<div className="confirmation-messages">{this.state.confirmMessage}</div>}
                      header={this.state.confirmTitle}
                      isOpen={this.state.confirmIsOpen}
                      onCancel={this.handleConfirmClose}
                      onConfirm={this.handleConfirm}
                      onHide={this.handleConfirmClose.bind( this.props )}
                  />
              </aside>
          </div>
          <ComponentFunctionCodeMultipleEntryPopup
              isOpen={this.state.modelIsOpen}
              onClose={this.onUploadReportClose.bind( this.props )}
          />
      </section>
  );

}

ComponentFunctionCodeMaintenance.displayName = 'ComponentFunctionCodeMaintenance';
ComponentFunctionCodeMaintenance.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
    reload: PropTypes.string.isRequired,
    updateReload: PropTypes.func.isRequired,
    factoryCode: PropTypes.string.isRequired,
};

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
} );

const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );

export default connect(
    mapStateToProps, mapDispatchToProps,
)( ComponentFunctionCodeMaintenance );
